export default "__VITE_ASSET__f907daaf__"